var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "btn btn-link text-appearance align-self-center collapsed",
      attrs: {
        href: "#filter-collapse_" + _vm.uid,
        role: "button",
        "aria-expanded": "false",
        "aria-controls": "filter-collapse_" + _vm.uid,
      },
      on: {
        click: function ($event) {
          return _vm.toggleSidebar()
        },
      },
    },
    [
      _c(
        "svg",
        { staticClass: "filter__toggle-icon", attrs: { fill: "currentColor" } },
        [_c("use", { attrs: { "xlink:href": "#filter-list" } })]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "filter__toggle-txt",
          class: {
            "filter__toggle-txt--active": _vm.selectedFacets.length > 0,
          },
        },
        [
          _vm.selectedFacets.length > 0
            ? _c("span", {
                domProps: { innerHTML: _vm._s(_vm.selectedFacets.length) },
              })
            : _vm._e(),
          _vm._v(
            "\n\n\t" +
              _vm._s(_vm.$translate("HoferAntikschmuck::Template.filter")) +
              "\n"
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }